const dismissToastReducer = (state) => ({
  ...state,
  activeToast: null,
});

export default dismissToastReducer;
